import type { ReactNode } from 'react'
import { Notebook } from 'lucide-react'

interface Props {
  title: string
  children: ReactNode
}

export function CoachingMetaSection({ title, children }: Props) {
  return (
    <section aria-label={title} className="rounded-lg border border-gray-200 bg-white p-3">
      <header className="flex items-center gap-1.5 mb-2 text-xs font-semibold text-gray-700">
        <Notebook size={14} aria-hidden="true" />
        <span>{title}</span>
      </header>
      <div className="text-sm">{children}</div>
    </section>
  )
}
